var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMisc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1261 31.0716C25.2762 31.0716 31.0725 25.2753 31.0725 18.1251C31.0725 10.975 25.2762 5.17871 18.1261 5.17871C10.976 5.17871 5.17969 10.975 5.17969 18.1251C5.17969 25.2753 10.976 31.0716 18.1261 31.0716Z",
    stroke: "#240C0C",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1261 25.893C22.4162 25.893 25.894 22.4152 25.894 18.1251C25.894 13.8351 22.4162 10.3573 18.1261 10.3573C13.836 10.3573 10.3583 13.8351 10.3583 18.1251C10.3583 22.4152 13.836 25.893 18.1261 25.893Z",
    stroke: "#240C0C",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1261 20.7144C19.5561 20.7144 20.7154 19.5552 20.7154 18.1251C20.7154 16.6951 19.5561 15.5359 18.1261 15.5359C16.6961 15.5359 15.5368 16.6951 15.5368 18.1251C15.5368 19.5552 16.6961 20.7144 18.1261 20.7144Z",
    stroke: "#240C0C",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc);
export default __webpack_public_path__ + "static/media/Misc.b192b68200575eb87d17c5cf6f07b01b.svg";
export { ForwardRef as ReactComponent };